var View = require('views/base/view');
var TimeoutService = require('services/timeout-service');


var MatchingSelectionQuestionView = View.extend({
  autoRender: true,
  template: require('./templates/matching-selection-question'),

  activitySettings: undefined,

  questionDelayTimeout: null,
  questionSelectionTimeout: null,

  questionElements:undefined,

  answeredIdArray:[],
  selectionElementArray:[],
  regions: {},

  load: function() {
    this.activitySettings = this.model.get('activitySettings');
    this.regions = this.model.get('regions');
    this.initializeQuestion();
  },

  dispose: function() {
    this.clearQuestionTimers();
    View.prototype.dispose.apply(this, arguments);
  },

  // sets/renders a question based on the current position of the question iterator
  initializeQuestion: function() {
    let answers = this.model.get('answers');
    this.model.set('answers', answers);
    this.questionElements = $(this.regions.question+' .question-answer');
    for(var i = 0; i < this.questionElements.length; i++) {
      $(this.questionElements[i]).attr('selectid', i).attr('answerid', answers[i].id).addClass('answer-'+i);
    }
    this.selectionElementArray = [];
    this.answeredIdArray = [];
    this.startQuestionTimers();
    this.delegate('click', '.question-answer', (e)=>{this.selectElement(e);});
  },

  // clear timeouts and intervals if they exist
  clearQuestionTimers: function() {
    if(this.questionDelayTimeout !== null) {
      this.questionDelayTimeout.clear();
    }
    if(this.questionSelectionTimeout !== null) {
      this.questionSelectionTimeout.clear();
    }
  },


  // kick off timers with the start of a new question
  startQuestionTimers: function() {
    if(this.activitySettings.question_timeout !== -1) {
      this.questionSelectionTimeout = new TimeoutService(this.activitySettings.question_timeout,
        ()=>{
          this.questionTimeout();
        });
      this.questionSelectionTimeout.play();
    }
  },

  // timeout that registers if the user takes too long to answer
  questionTimeout: function() {
    this.clearQuestionTimers();

    $(this.regions.question).addClass('unanswered incorrect');
    this.questionElements.removeClass('selected');

    this.trigger('question:timeout', {
      feedback: this.model.get('feedback'),
      answerElement: $('.game-container')
    });
  },

  // apply selection class to element
  selectElement: function(e) {
    let selectId = parseInt($(e.currentTarget).attr('selectid'));
    let index = _.findIndex(this.selectionElementArray, function(o) { return parseInt($(o).attr('selectid')) === selectId;});
    if( index != -1) {
      $(e.currentTarget).removeClass('selected');
      this.selectionElementArray.splice(index, 1);
    } else {
      this.selectionElementArray.push(e.currentTarget);
      $(e.currentTarget).addClass('selected');
    }

    if(this.selectionElementArray.length > 1) {
      this.matchItems();
    }
  },

  // checks if the items matched
  matchItems: function() {
    this.$el.off('click', '.selected');
    let i, elem;
    let matchedElements = [];
    let aArray = [];
    for(i = 0; i < this.selectionElementArray.length; i++) {
      elem = $(this.selectionElementArray[i]);
      aArray.push(parseInt(elem.attr('answerid'),10));
    }

    let correctMatch = aArray[0] === aArray[1];

    if(correctMatch) {
      this.answeredIdArray.push(parseInt(elem.attr('answerid'),10));
      for(i = 0; i < this.selectionElementArray.length; i++) {
        elem = $(this.selectionElementArray[i]);
        matchedElements.push(elem);
        elem.addClass('answered');
        elem.removeClass('selected');
      }
      this.selectionElementArray = [];

      Chaplin.mediator.publish('game:match:completed', {
        elements: matchedElements,
        id:parseInt(elem.attr('answerid'),10)
      });
    } else {
      this.$el.off('click', '.question-answer');
      this.answerQuestion(false);
    }

    let correct = this.checkQuestionCorrect();
    if(correct) {
      this.answerQuestion(true);
    }

  },

  // all matches made or got something wrong
  answerQuestion: function(correct) {
    this.clearQuestionTimers();
    this.question_timeout = new TimeoutService(this.activitySettings.question_delay,
      ()=>{
        this.trigger('question:feedback', {
          correct: correct,
          feedback: this.model.get('feedback'),
          answerElement: $('.game-container')
        });
      });

    this.question_timeout.play();

    this.trigger('question:answered', {
      correct: correct
    });
  },

  // is the selected answer correct?
  checkQuestionCorrect: function() {
    let check = this.answeredIdArray.sort(function(a, b) {return a-b;}).join('').toString();
    let correct = this.model.get('correct').sort(function(a, b) {return a-b;}).join('').toString();
    return check === correct;
  }
});

module.exports = MatchingSelectionQuestionView;


